import { Injectable } from "@angular/core";
import { RestService } from "../../core/core/rest.service";
import { ObjectState } from "./object-states.model";

@Injectable()
export class ObjectStatesRest {
    constructor(private http: RestService) { }
    
    public getObjectStates() {
        return this.http.get<ObjectState[]>('api/objectstates');
    }
    
}